export default "__VITE_ASSET__DCSTvLVw__"